module.exports = __webpack_public_path__ + "static/media/icon-faturamento.66596b1b.svg";